import { captureError } from "@core-ui/utils/Error";

const isSessionStorageAvailable = (): boolean => typeof window !== "undefined" && typeof sessionStorage !== "undefined";

export class Storage {
    public static getItem<T>(key: string, defaultValue?: T): T | undefined {
        try {
            if (isSessionStorageAvailable()) {
                const item = window.sessionStorage.getItem(key);

                return item ? JSON.parse(item) : defaultValue;
            }
            return defaultValue;
        } catch (error) {
            captureError(error);
            return defaultValue;
        }
    }

    public static setItem<T>(key: string, value: T): void {
        try {
            if (isSessionStorageAvailable()) {
                // set item in session storage
                sessionStorage.setItem(key, JSON.stringify(value));
            }
        } catch (err) {
            captureError(err);
        }
    }

    static removeItem(key: string): void {
        if (isSessionStorageAvailable()) {
            sessionStorage.removeItem(key);
        }
    }
}
